/**
 * @author: leroy
 * @date: 2021/8/23 16:11
 * @description：monitor
 */
import api from '@/utils/api';
import Url from '@/utils/url';
const isProd = process.env.NODE_ENV === 'production';

// 校验人脸
export async function faceRecognize(blob: Blob | null) {
  const formData = new FormData();
  formData.append('face_img', blob || '');
  return api<{
    status: string;
    faces: number[][];
  }>('/tools/face_recognize', {
    method: 'POST',
    data: formData,
    prefix: isProd ? 'https://examapi.haitou.cc' : 'http://examapi.haitou.cc',
  });
}

// 提交首图
export async function postFirstPicture(data: { exam_id: string; picture: string }) {
  return api<API.Response>(Url.postFirstPicture, {
    method: 'POST',
    data,
  });
}

// 提交帧
export async function postFrame(data: API.Monitor.Frame) {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  return api<API.Response>(Url.postFrame, {
    method: 'POST',
    data: formData,
  });
}

//提交实时监控
export async function fastPostFrame(data: API.Monitor.Frame) {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  return api<API.Response>(Url.fastPostFrame, {
    method: 'POST',
    data: formData,
  });
}

// 切题时刻
export async function postPertinent(data: API.Monitor.Pertinent) {
  return api<API.Response>(Url.pertinent, {
    method: 'POST',
    data,
  });
}

// 字节回放
export async function postByte(data: API.Monitor.Byte) {
  return api<API.Response>(Url.byte, {
    method: 'POST',
    data,
  });
}

// 生成小程序码
export async function getMiniQrcode(data: {
  user_id: number;
  exam_id: string;
  server: '0' | '1';
  version?: number;
}) {
  const formData = new FormData();
  formData.append('type', 'exam');
  formData.append('app', 'exam');
  formData.append('version', String(data.version));
  formData.append('page', 'pages/home/index');
  formData.append(
    'params',
    JSON.stringify({
      kind: 'exam',
      user_id: data.user_id,
      id: data.exam_id,
      server: data.server,
      version: data.version,
    }),
  );

  // return 'https://assets.haitou.cc/3d5b953c/image/xcx.png?v=2018-03-21&x-oss-process=image/resize,m_fixed,w_150,h_150';

  return api<{ data: string; status: string }>(Url.miniQrcode, {
    prefix: Url.htApiHost,
    method: 'POST',
    data: formData,
  });
}
